import { render, staticRenderFns } from "./DisplayWithChange.vue?vue&type=template&id=07c494e3"
import script from "./DisplayWithChange.vue?vue&type=script&lang=ts"
export * from "./DisplayWithChange.vue?vue&type=script&lang=ts"
import style0 from "./DisplayWithChange.vue?vue&type=style&index=0&id=07c494e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports